import React, { useEffect, useRef } from 'react';

// Полоса категорий под шапкой. Липкая: приклеивается сразу под шапкой, поэтому её высота
// нужна прокрутке к заголовку раздела (BouquetCatalog, MenuPage). Раньше там стояла
// константа 56px — высота полосы у Стемса; у Букетберри названия категорий длиннее, полоса
// выше, и заголовок раздела прятался под ней (TASK_STOREFRONT_CATEGORY_SCROLL, 15.09.2026).
// Меряем настоящую высоту и отдаём в --chips-height; при уходе со страницы сбрасываем в 0,
// иначе отступ остался бы на экранах без категорий.
function FilterChips({ categories, activeCategory, setActiveCategory }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const root = document.documentElement;
    const apply = () => root.style.setProperty('--chips-height', el.offsetHeight + 'px');
    apply();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(apply) : null;
    if (observer) observer.observe(el);
    return () => {
      if (observer) observer.disconnect();
      root.style.setProperty('--chips-height', '0px');
    };
  }, []);

  return (
    <div ref={ref} className="filters-container" style={{
      position: 'sticky',
      top: 'var(--header-height, 120px)',
      backgroundColor: 'var(--bg-color)',
      zIndex: 100,
      paddingBottom: '8px'
    }}>
      {/* Только категории */}
      <div className="filter-row">
        {categories.map((category) => (
          <button
            key={category.slug}
            className={`filter-chip ${activeCategory === category.slug ? 'active' : ''}`}
            onClick={() => setActiveCategory(category.slug)}
          >
            {category.name}
          </button>
        ))}
      </div>
    </div>
  );
}

export default FilterChips;
